"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _axios = _interopRequireDefault(require("axios"));
var _function = require("../utils/function");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Returns all the facilities of an enterprise.
var Services = function Services(_ref) {
  var lang = _ref.lang,
    id = _ref.id,
    facilities = _ref.facilities,
    setFacilities = _ref.setFacilities;
  var translate = function translate(e) {
    return (0, _idbReactTranslations["default"])(e, lang);
  };
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    services = _useState2[0],
    setServices = _useState2[1];
  var env = (0, _function.getEnvEndpoints)();
  (0, _react.useEffect)(function () {
    if (!facilities) {
      var items = {};
      var new_facilities = [];
      var facilities_model = require('../models/FacilitiesModel')["default"];
      _axios["default"].get("".concat(env.REACT_APP_BASE_MEDIA_URL, "/core/api/business/").concat(id, "/facilities/?lang=").concat(lang)).then(function (res) {
        new_facilities = facilities_model(res.data, lang);
        console.log(new_facilities);
        // Remove double values in the array based on their names
        var uniqueFacilities = '';
        var input = new_facilities;
        var seen = new Map();
        var _iterator = _createForOfIteratorHelper(input),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var v = _step.value;
            if (seen.has(v.name)) {
              continue;
            } else {
              seen.set(v.name, v);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        uniqueFacilities = Array.from(seen.values());
        var priority = ["extra_services", "services", "payment_methods"];
        var sortedFacilities = uniqueFacilities.sort(function (a, b) {
          if (priority.indexOf(a.code) < priority.indexOf(b.code)) return 1;
          if (priority.indexOf(a.code) > priority.indexOf(b.code)) return -1;
          return 0;
        });
        for (var i = 0; i < sortedFacilities.length; i++) {
          var category = sortedFacilities[i].category ? sortedFacilities[i].category : "other";
          var code = sortedFacilities[i].code ? sortedFacilities[i].code : "other";
          if (!items[category]) {
            items[category] = {
              services: [],
              name: sortedFacilities[i].category,
              active: true,
              code: code
            };
          }
          items[category].services.push(sortedFacilities[i]);
        }
        setServices(items);
        // store it in a global variable so if we switch tabs, we don't have to make another call
        setFacilities(items);
      })["catch"](function (error) {
        return console.log(error);
      });
    }
    // facilities has already been stored, So don't make another call but just use this data
    else {
      setServices(facilities);
    }
  }, []);
  var activeHandler = function activeHandler(key) {
    var copy = Object.assign({}, services);
    copy[key].active = !copy[key].active;
    setServices(copy);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "services"
  }, Object.entries(services).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        margin: '20px 0'
      },
      key: key
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      onClick: function onClick() {
        return activeHandler(key);
      }
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      className: "".concat(value.active ? 'active' : ''),
      name: "ArrowDown"
    }), translate(key.toLowerCase())), /*#__PURE__*/_react["default"].createElement("div", {
      className: "service ".concat(value.active ? 'active' : '', " ").concat(value.code),
      style: {
        height: value.active ? "".concat(Math.ceil(value.services.length / 2) * 55, "px") : ''
      }
    }, value.services.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "serviceBlock",
        key: item.id
      }, item.icon && /*#__PURE__*/_react["default"].createElement("figure", {
        className: "icon"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: "".concat(item.icon)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "serviceBlockTitle"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        title: item.name
      }, item.name, " "), item.value && /*#__PURE__*/_react["default"].createElement("div", {
        title: item.value
      }, "(", item.value, ")")));
    })));
  }));
};
var _default = exports["default"] = Services;